export const editablePostionFields = ['Type', 'Comment', 'Is Reconciled'];
export const dateIcons = ['Tx Dt Tm'];
export const booleanIcons = ['Is Reconciled'];
